







































































































































































































































































































































import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import { mapGetters } from 'vuex';
import moment from 'moment';

import authMixin from '@/mixins/auth';
import {
  IGenPaymentPlanScheduleInvoicePayload,
  useDeletePaymentPlanSchedule
} from '@/composable/payment-plan';
import {
  IPaymentPlan,
  IPaymentPlanSchedule,
  PaymentPlanStateEnum,
  PaymentPlanAmountTypeEnum,
  IQuote,
  InvoiceStateEnum,
  IInvoiceItem,
  ITax
} from '@/models';
import { countries } from '@/data/countries';
import { useTaxTextVisuals } from '@/composable/invoice';

import PaymentPlanScheduleFormDialog from './PaymentPlanScheduleDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import PaymentPlanScheduleInvoiceDialog from './PaymentPlanScheduleInvoiceDialog.vue';
import InvoiceStatusDisplay from '@/components/invoice/InvoiceStatusDisplay.vue';
import PaymentScheduleInconsistencyIndicator from './PaymentScheduleInconsistencyIndicator.vue';

export default defineComponent({
  name: 'PaymentPlanScheduleList',
  components: {
    ConfirmationDialog,
    PaymentPlanScheduleFormDialog,
    PaymentPlanScheduleInvoiceDialog,
    InvoiceStatusDisplay,
    PaymentScheduleInconsistencyIndicator
  },
  mixins: [authMixin],
  props: {
    paymentPlan: {
      type: Object as PropType<IPaymentPlan>,
      default: null
    },
    currencyCode: String,
    totalPlanAmount: {
      type: Number,
      required: true
    },
    quote: {
      type: Object as PropType<IQuote>,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      getPaymentPlanScheduleVisualByState:
        'paymentPlan/getPaymentPlanScheduleVisualByState'
    })
  },
  setup(props) {
    const scheduleHeaders = [
      { text: '', value: 'reminder', sortable: false, width: 20 },
      { text: 'Due Date', value: 'calculated_due_date', sortable: false },
      { text: 'Description', value: 'payment_type', sortable: false },
      { text: 'PO #', value: 'po_number', sortable: false },
      { text: 'CSI Order #', value: 'csi_order_number', sortable: false },
      { text: 'Terms', value: 'percentage', sortable: false },
      { text: 'Amount', value: 'calculated_amount_due', sortable: false },
      { text: 'Invoice', value: 'invoice', sortable: false },
      { text: 'Status', value: 'status', sortable: false, align: 'center' },
      { text: '', value: 'actions', sortable: false, width: 100 }
    ];

    const dialog = ref(false);
    const selectedPaymentPlanSchedule = ref<IPaymentPlanSchedule | null>(null);

    function openPaymentPlanScheduleFormDialog(
      paymentPlanSchedule?: IPaymentPlanSchedule
    ) {
      selectedPaymentPlanSchedule.value = paymentPlanSchedule ?? null;
      dialog.value = true;
    }

    const deleteDialog = ref(false);
    function openPaymentPlanScheduleDeleteDialog(
      paymentPlanSchedule: IPaymentPlanSchedule
    ) {
      selectedPaymentPlanSchedule.value = paymentPlanSchedule;
      deleteDialog.value = true;
    }

    const currentPaymentPlan = computed(() => props.paymentPlan!);

    const {
      isLoading: deleteInProgress,
      error: deleteError,
      mutate: deletePaymentPlanSchedule
    } = useDeletePaymentPlanSchedule(currentPaymentPlan.value.id!);

    function removePaymentPlanSchedule(
      paymentPlanSchedule: IPaymentPlanSchedule
    ) {
      deletePaymentPlanSchedule(paymentPlanSchedule.id!, {
        onSuccess: () => {
          closeDeleteDialog();
        }
      });
    }

    function closeDeleteDialog() {
      deleteDialog.value = false;
      selectedPaymentPlanSchedule.value = null;
    }

    function clearErrors() {
      deleteError.value = null;
    }

    const scheduleInvoicePayload = ref<IGenPaymentPlanScheduleInvoicePayload | null>(
      null
    );
    const invoiceGenerationDialog = ref(false);
    function generateInvoiceOrOpenInvoiceCountryPicker(
      schedule: IPaymentPlanSchedule
    ) {
      const customerAddress = countries().find(
        country => country.name == props.quote.customer!.address!.country
      );
      const shippingAddress = countries().find(
        country => country.name == props.quote.customer!.ship_address!.country
      );

      scheduleInvoicePayload.value = {
        scheduleId: schedule.id!,
        data: {
          buyer_country: customerAddress?.code ?? '',
          shipping_country: shippingAddress?.code ?? ''
        }
      };

      invoiceGenerationDialog.value = true;
    }

    function getAllInvoiceTaxes(items: IInvoiceItem[]): (ITax | null)[] {
      const taxItems = items.map(item => item.tax as ITax | null);
      const uniqueTaxItems = taxItems.filter(
        (tax, index, self) =>
          tax && self.findIndex(t => t?.name === tax.name) === index
      );
      return uniqueTaxItems;
    }

    function getTotalInvoicePercentage(items: IInvoiceItem[]): number | null {
      const total = items.reduce(
        (acc, item) => acc + Number(item.term_percentage ?? 0),
        0
      );

      return total || null;
    }

    function isReminderInPast(item: IPaymentPlanSchedule) {
      return moment(item.reminder_start_date).isSameOrBefore(new Date());
    }

    return {
      moment,
      InvoiceStateEnum,
      PaymentPlanAmountTypeEnum,
      PaymentPlanStateEnum,
      invoiceGenerationDialog,
      scheduleInvoicePayload,
      scheduleHeaders,
      currentPaymentPlan,
      dialog,
      deleteDialog,
      selectedPaymentPlanSchedule,
      deleteError,
      deleteInProgress,
      useTaxTextVisuals,
      getTotalInvoicePercentage,
      getAllInvoiceTaxes,
      generateInvoiceOrOpenInvoiceCountryPicker,
      openPaymentPlanScheduleFormDialog,
      openPaymentPlanScheduleDeleteDialog,
      closeDeleteDialog,
      removePaymentPlanSchedule,
      clearErrors,
      isReminderInPast
    };
  }
});
